import { translate, translateOther } from '../types/EnumTranslations';
import { RoomModel, LevelModel } from '../types/protocols';
import { RoomImpl, LevelImpl } from '../types/implementations';
import { getBuildComponentTypeTranslation } from './BuildComponentTypesStore';

// Display of the values in archive/changeLog `_diff.changes`, shared by the
// building history page and Ändringslogg.

/** Fields whose values are enum keys that `translate()` can handle. */
const ENUM_FIELDS = new Set([
    'material', 'cardinalDirection', 'roofShape', 'elevatorType',
    'utilityCategory', 'outdoorCategory', 'buildingRisks', 'hazardous',
]);

/** Resolve a room to its display name, with level. */
function getRoomDisplayName(
    room: RoomModel,
    levels?: { [key: string]: LevelModel },
): string {
    let name = new RoomImpl(room).displayName();
    if (room.levelKey && levels?.[room.levelKey]) {
        name += ` (${new LevelImpl(levels[room.levelKey]).displayName()})`;
    }
    return name;
}

/**
 * Translate a stored diff value to Swedish.
 * Array values are stored as comma-separated strings (e.g. "concrete, wood").
 */
export function translateFieldValue(
    field: string,
    value: string | null,
    rooms?: { [key: string]: RoomModel },
    levels?: { [key: string]: LevelModel },
): string {
    if (!value) return '(tom)';

    if (field === 'specificType') {
        return getBuildComponentTypeTranslation(value);
    }

    if (field === 'parentRoomKeys' && rooms) {
        return value.split(', ').map(key => {
            const room = rooms[key.trim()];
            return room ? getRoomDisplayName(room, levels) : key.trim();
        }).join(', ');
    }

    if (ENUM_FIELDS.has(field)) {
        if (value.includes(', ')) {
            return value.split(', ').map(v => {
                const t = translate(v.trim());
                return t !== v.trim() ? t : translateOther(v.trim());
            }).join(', ');
        }
        const t = translate(value);
        return t !== value ? t : translateOther(value);
    }

    return value;
}
